import React from "react";
import { Settings as SettingsIcon } from "lucide-react";

// ── Clinic Settings page ─────────────────────────────────────────────────────
//
// The Reserved-slots section was removed with the 2026-02 calendar-paint
// redesign — clinics now paint slots directly on the scheduling calendar
// via the "WestStar Reserve" toggle. This page remains as a container
// for future settings sections (profile, notifications, etc.). When
// empty (as today), it renders a graceful empty state.

export default function ClinicSettings() {
  return (
    <div className="p-6 space-y-5 max-w-4xl" data-testid="clinic-settings-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
          <SettingsIcon size={22} className="text-blue-600" />
          Settings
        </h1>
        <p className="text-sm text-slate-500 mt-0.5">
          Portal preferences.
        </p>
      </div>

      <div
        className="bg-white border border-slate-200 rounded-lg p-8 text-center"
        data-testid="clinic-settings-empty-state"
      >
        <SettingsIcon size={28} className="mx-auto text-slate-300 mb-2" />
        <div className="text-sm font-semibold text-slate-700">No settings sections yet</div>
        <div className="text-xs text-slate-500 mt-1 max-w-md mx-auto">
          Reserved slots are now painted directly on the scheduling calendar &mdash;
          use the <strong>WestStar Reserve</strong> toggle at the top-right of your Calendar view.
          Future preference sections will appear here.
        </div>
      </div>
    </div>
  );
}
